import request from "../../../axios";
import { getTransactionLoadingSponsorDataParams, getTransactionLoadingSponsorDataResponse } from "./type";

export const getTransactionLoadingSponsor = async (params: getTransactionLoadingSponsorDataParams) => {
    const { data }: { data: getTransactionLoadingSponsorDataResponse } = await request.get('/api/v2/notification/payment-transaction-sponsor', {
        params
    })
    return data
}